<template>
  <div class="todo-side-bar">
    <div class="todo-side-bar-logo">
      <todo-logo />
    </div>

    <div class="todo-side-bar-menu">
      <todo-menu :selected="selected" />
    </div>

    <div class="todo-side-bar-logout">
      <router-link to="/logout">
        <svg-icon name="logout" />
      </router-link>
    </div>

    <div class="todo-side-bar-right">
      <div class="todo-side-bar-right-round" />
    </div>
  </div>
</template>

<script>
  import '../icons/components/logout'

  export default {
    props: {
      selected: String
    }
  }
</script>

<style lang="scss">
  @import '../assets/variables';

  .todo-side-bar {
    z-index: 100;
    // position: absolute; // old
    position: fixed; // new
  }

  .todo-side-bar {
    overflow: auto; // new
    overflow-x: hidden; // new
    left: 0;
    top: 0;
    bottom: 0;
    width: $side-bar-width;
    background-image: url('~@/img/bg-nav.png');
    background-color: $color-blue-light;
    background-position: 0;

    .todo-side-bar-logo {
      position: absolute;
      top: 5%;
      left: 0;
      right: 0;
      color: white;

      h2 {
        font-size: 22px;
        line-height: 32px;
      }
    }

    .todo-side-bar-logout {
      position: absolute;
      left: 100px;
      bottom: 15px;
    }

    .todo-side-bar-right {
      z-index: 210;
      position: absolute;
      left: $side-bar-width;
      top: 0;
      bottom: 0;
      width: 20px;
      background: $color-blue-light;

      .todo-side-bar-right-round {
        width: 100%;
        height: 100%;
        background: white;
        border-top-left-radius: 24px;
        border-bottom-left-radius: 24px;
      }
    }
  }
</style>
